<div class="p-3">
    <p-listbox [options]="grouping" [(ngModel)]="selectedGroup" optionLabel="name" 
        class="grid" [style]="{'width':'100%'}" (onChange)="groupingChange()">
        <ng-template let-group pTemplate="item" class="grid">
            <div class="col">
                <div>{{ group.name }}</div>
            </div>
        </ng-template>
    </p-listbox>
</div>
<div *ngIf="loading" class="flex justify-content-center">
    <p-progressSpinner></p-progressSpinner>
</div>
<div *ngIf="pendingOrderGroups.length > 0" class="grid text-lg text-center">
    <div class="col-12">
        <h1>{{orderTotal}} Total</h1>
    </div>
    <div class="col-3">
        <label>{{pendingOrderGroups[0].orders.length}}</label>
        <br>
        <label>{{pendingOrderGroups[0].groupName}}</label>
    </div>
    <div class="col-3">
        <label>{{pendingOrderGroups[1].orders.length}}</label>
        <br>
        <label>{{pendingOrderGroups[1].groupDate | date: "EEE"}}</label>
    </div>
    <div class="col-3">
        <label>{{pendingOrderGroups[2].orders.length}}</label>
        <br>
        <label>{{pendingOrderGroups[2].groupDate | date: "EEE"}}</label>
    </div>
    <div class="col-3">
        <label>{{pendingOrderGroups[3].orders.length}}</label>
        <br>
        <label>{{pendingOrderGroups[3].groupDate | date: "EEE"}}</label>
    </div>
    <div class="col-12">
        <hr>
    </div>
    <div *ngFor="let group of pendingOrderGroups" class="col-12">
        <p-panel [header]="group.groupName" [toggleable]="true" toggler="header" [collapsed]="true">
            <div *ngIf="group.groupName == 'Late'">
                <div *ngFor="let order of group.orders">
                    <div class="grid formgrid border-bottom-1 surface-border">
                        <div class="col-6">
                            {{order.plateName}}
                        </div>
                        <div class="col-6">
                            {{order.order.plateDueDate | date: "dd/MM/yyyy HH:mm:ss"}}
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="group.groupName != 'Late'">
                <div class="grid">
                    <div class="col-6">
                        Retests: {{retestCount("order", group.orders)}}
                    </div>
                    <div class="col-6">
                        Non-retests: {{nonRetestCount("order", group.orders)}}
                    </div>
                </div>
            </div>
        </p-panel>
    </div>
</div>

<div *ngIf="pendingPlateGroups.length > 0" class="grid text-lg text-center">
    <div class="col-12">
        <h1>{{plateTotal}} Total</h1>
    </div>
    <div class="col-3">
        <label>{{pendingPlateGroups[0].plates.length}}</label>
        <br>
        <label>{{pendingPlateGroups[0].groupName}}</label>
    </div>
    <div class="col-3">
        <label>{{pendingPlateGroups[1].plates.length}}</label>
        <br>
        <label>{{pendingPlateGroups[1].groupDate | date: "EEE"}}</label>
    </div>
    <div class="col-3">
        <label>{{pendingPlateGroups[2].plates.length}}</label>
        <br>
        <label>{{pendingPlateGroups[2].groupDate | date: "EEE"}}</label>
    </div>
    <div class="col-3">
        <label>{{pendingPlateGroups[3].plates.length}}</label>
        <br>
        <label>{{pendingPlateGroups[3].groupDate | date: "EEE"}}</label>
    </div>
    <div class="col-12">
        <hr>
    </div>
    <div *ngFor="let group of pendingPlateGroups" class="col-12">
        <p-panel [header]="group.groupName" [toggleable]="true" toggler="header" [collapsed]="true">
            <div *ngIf="group.groupName == 'Late'">
                <div *ngFor="let plate of group.plates">
                    <div class="grid formgrid border-bottom-1 surface-border">
                        <div class="col-6">
                            {{plate.name}}
                        </div>
                        <div class="col-6">
                            {{plate.dueDate | date: "dd/MM/yyyy HH:mm:ss"}}
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="group.groupName != 'Late'">
                <div class="grid">
                    <div class="col-6">
                        Retests: {{retestCount("plate", group.plates)}}
                    </div>
                    <div class="col-6">
                        Non-retests: {{nonRetestCount("plate", group.plates)}}
                    </div>
                </div>
            </div>
        </p-panel>
    </div>
</div>

<p-dialog header="Log in to Lims" [(visible)]="limsLoginModal" [breakpoints]="{ '960px': '95vw' }" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <div class="grid" (keydown.enter)="loginModalSubmit()">
        <div class="col-12 flex align-items-center justify-content-center">
            <div class="p-fluid">
                <div class="field">
                    <label for="username">Username</label>
                    <input pInputText [(ngModel)]="username" id="username" type="text" />
                </div>
                <div class="field">
                    <label for="password">Password</label>
                    <input pInputText [(ngModel)]="password" id="password" type="password" />
                </div>
                <p-button label="Login" (onClick)="loginModalSubmit()"></p-button>
            </div>
        </div>
    </div>
</p-dialog>